var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPsLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.589417,
    width: 40,
    height: 40,
    rx: 12,
    fill: "#F1ECFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_318_6593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 12.5894C17.8 12.5894 16 14.3894 16 16.5894V17.5894H14C13.4 17.5894 13 17.9894 13 18.5894V27.5894C13 28.1894 13.4 28.5894 14 28.5894H26C26.6 28.5894 27 28.1894 27 27.5894V18.5894C27 17.9894 26.6 17.5894 26 17.5894H24V16.5894C24 14.3894 22.2 12.5894 20 12.5894ZM21 24.2894V25.5894H19V24.2894C18.4 23.9894 18 23.2894 18 22.5894C18 21.4894 18.9 20.5894 20 20.5894C21.1 20.5894 22 21.4894 22 22.5894C22 23.2894 21.6 23.9894 21 24.2894ZM22 17.5894H18V16.5894C18 15.4894 18.9 14.5894 20 14.5894C21.1 14.5894 22 15.4894 22 16.5894V17.5894Z",
    fill: "#9C82FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_318_6593"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12 12.5894)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsLock);
export default __webpack_public_path__ + "static/media/ps-lock.7e8f98e60a1f336e5b74158a6778f569.svg";
export { ForwardRef as ReactComponent };